
// Base report types (V1)
const baseReportTypes = {
  sales: 'sales',
  customer: 'customers',
  wineclubMembers: 'wine_club_members',
  winetastingBooking: 'wine_tasting_booking',
  product: 'products',
  inHouseFulfillment: 'in_house_fulfillment',
  salesByClubLevelAll: 'sales_by_club_level_all_report',
  customerLTVReport: 'customer_by_ltv_report',
  salesByClubLevel: 'sales_by_club_level_report',
  salesByState: 'sales_by_state_report',
  salesByProductType: 'sales_by_product_type_report',
  salesByDiscount: 'sales_by_discount_report',
  masterInventory: 'master_inventory_report',
  salesByEvent: 'sales_by_event_report',
  salesByCustomerType: 'sales_by_customer_type_report',
  salesByProduct: 'sales_by_product_report',
  salesByPaymentType: 'sales_by_payment_type_report',
  salesByOrder: 'sales_by_order_type_report',
  wineClubPackageMembers: 'wine_club_package_members',
  inventories: 'inventories',
  salesOrder: 'sales_by_order',
  salesByTax: 'sales_by_tax_report',
  posSalesByAssociate: 'pos_sales_by_associate',
  tipReport: 'tip_report',
  posWineClubSignups: 'pos_wine_club_signups',
  posOrderSalesReport: 'pos_order_sales_report',
  posOrderItemSalesReport: 'pos_order_item_sales_report',
  salesByOrderEditType: 'sales_by_order_edit_type_report',
  salesByOrderEdit: 'sales_by_order_edit_report',
  posSalesByLocation: 'pos_sales_by_location',
  emailOptinAndSignupSourceReport: 'email_optin_and_signup_source_report',
  inventoriesByLocationSummary: 'inventories_by_location_summary_report',
  posSalesBySku: 'pos_sales_summary_by_sku_report',
  posSalesByCategory: 'pos_sales_summary_by_category_report',
  salesComplianceReport: 'sales_compliance_report',
  masterSalesReport: 'master_sales_report',
  wineClubSignup: 'wine_club_signup_report',
  reconciliationReport: 'reconciliation_report',
  inventoryByLocation: 'inventory_location_report',
  itemDetails: 'item_details',
}

// V2 overrides - only the ones that are different
const v2Overrides = {
  salesByState: 'sales_by_state_report_v2',
  salesByProductType: 'sales_by_product_type_report_v2',
  salesByDiscount: 'sales_by_discount_report_v2',
  salesByEvent: 'sales_by_event_report_v2',
  salesByCustomerType: 'sales_by_customer_type_report_v2',
  salesByProduct: 'sales_by_product_report_v2',
  salesByPaymentType: 'sales_by_payment_type_report_v2',
  salesByOrder: 'sales_by_order_type_report_v2',
  salesOrder: 'sales_by_order_v2',
  salesByTax: 'sales_by_tax_report_v2',
  salesByOrderEditType: 'sales_by_order_edit_type_report_v2',
  salesByClubLevel: 'sales_by_club_level_report_v2',
  salesByClubLevelAll: 'sales_by_club_level_all_report_v2',
  salesByOrderEdit: 'sales_by_order_edit_report_v2',
  // masterSalesReport: 'master_sales_report_v2',
  // reconciliationReport: 'reconciliation_report_v2',
}

// Function to get report types based on version
export const getReportTypes = (isV2: boolean = false) => {
  if (!isV2) {
    return baseReportTypes
  }

  return {
    ...baseReportTypes,
    ...v2Overrides,
  }
}

// Export V1 as default for backward compatibility
export const reportTypes = baseReportTypes

// Export V2 for explicit usage
export const reportTypesV2 = getReportTypes(true)
